import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BodyClassName from "react-body-classname";
import "./navigation.scss";
import { useHistory } from "react-router-dom";
import ProgressBar from "../progressBar/progressBar";
import AppProgressInfo from "../appProgressInfo/appProgressInfo";
import { SurveyContext } from "../../store/survey-context";
import {
  calculateProgress,
  calculateTotalProgress,
  crmValueToSurveyPage,
  setAppBackground,
} from "../../utils";
import MarkForLaterList from "../../components/markForLaterList/markForLaterList";
import Cta from "../cta/Cta";

export default function MainNav(props) {
  const { setSplash, toggleSurvey, survey, userProfile, markedForLater } =
    useContext(SurveyContext);

  const { t } = useTranslation("common", { useSuspense: false });

  const [showMarkedForLater, setShowMarkedForLater] = useState(false);
  const [visibleMarkedForLater, setVisibleMarkedForLater] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setAppBackground(`Hero-1b.png`);

    // preload all first backgrounds in the chapter
    const img1 = new Image();
    img1.src = "/backgrounds/C1-1b.png";
    const img2 = new Image();
    img2.src = "/backgrounds/C2-1b.png";
    const img3 = new Image();
    img3.src = "/backgrounds/C3-1b.png";
    const img4 = new Image();
    img4.src = "/backgrounds/C4-1b.png";

    window.dataLayer?.push({
      event: "mtcExpScreen",
      screen: "Navigation",
      step: 5,
    });

    if (window.hj) {
      window.hj("stateChange", "questionnaire/nav");
    }

    if (survey && userProfile && userProfile.answers) {
      const page = survey.currentPage;
      const crmAnswer = userProfile.answers[page.crmId];

      if (crmAnswer !== undefined) {
        crmValueToSurveyPage(page, crmAnswer, survey);
      } else {
        // clear the questions on current page - because there was no answer
        page.questions.forEach((q) => {
          survey.setValue(q.name, null);
        });
      }
    }

    setTimeout(() => {
      const visibleMFL = [];
      markedForLater.forEach((crmId) => {
        const page = survey.pages.find((item) => item.crmId === crmId);
        if (!page.isVisible) return;
        visibleMFL.push(crmId);
      });

      if (visibleMFL.length === 0) {
        survey.isOnMarkedForLaterList = false;
        setShowMarkedForLater(false);
      }

      setVisibleMarkedForLater(visibleMFL);
    }, 0);

    if (survey.isOnMarkedForLaterList) {
      setShowMarkedForLater(true);
    }
  }, [survey, userProfile, markedForLater]);

  const hist = useHistory();
  const { chapterUnlocked, lastVisitedPage } = props;

  if (!survey) return null;

  function navHandler(page, payload, chapter) {
    survey.isOnMarkedForLaterList = false;
    // set loader and splash screen only for the first question in the chapter
    if (findFirstPage(chapter) === page) {
      //setLoader(true);
      toggleSurvey(true);
      setSplash(true);
    } else {
      //setLoader(false);
      setSplash(false);
      toggleSurvey(true);
      //console.log('nav -  questionnaire/'+(page+1));
      if (window.hj) {
        window.hj("questionnaire/" + (page + 1));
      }
    }
    // toggleSurvey(true)

    const newPage = survey.pages[page];

    if (survey.currentPage.name === newPage.name) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      const prevBtn = document.querySelector(".survey-buttons .btn--link");
      if (prevBtn) {
        prevBtn.style.display = "block";
      }
    }

    survey.currentPage = newPage;
  }

  const findFirstPage = function (chapter) {
    for (let i = 0; i < survey.pages.length; i++) {
      if (survey.pages[i].propertyHash.chapter === chapter) {
        return i;
      }
    }
    return 0;
  };

  const findFirstUnanswered = function (chapter) {
    const chapterUnanswered = survey.pages.filter(
      (element) =>
        element.chapter === chapter &&
        !element.isEasterEgg &&
        element.isVisible &&
        !element.isAnswered
    );

    if (chapterUnanswered) {
      return survey.pages.findIndex(
        (element) => element.name === chapterUnanswered[0].name
      );
    }
  };

  const chapterClass = function (chapter, progress) {
    return `navigation-list-item${chapterUnlocked >= chapter ? " active" : ""}${
      progress === 100 ? " completed" : ""
    }`;
  };

  const chapterActive = function (chapter) {
    return chapterUnlocked >= chapter ? true : false;
  };

  // either go to the last unanswered page in the chapter or go to the first question if it's completed
  const calculateChapterPage = function (chapter) {
    if (calculateProgress(chapter, survey) === 100) {
      return findFirstPage(chapter);
    } else {
      return findFirstUnanswered(chapter);
    }
  };

  const closeNav = function () {
    toggleSurvey(true);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const stepNew =
      survey.pages.findIndex(
        (element) => element.name === survey.currentPage?.name
      ) + 1;
    // set background again
    const background = survey.currentPage?.background;
    if (background) {
      const backgroundOpacity = survey.currentPage?.backgroundOpacity;
      setAppBackground(background, backgroundOpacity ?? 0.8);
    }
    //console.log('nav -  questionnaire/'+stepNew);
    if (window.hj) {
      window.hj("questionnaire/" + stepNew);
    }
  };

  // move to the last question in the survey and hide the navigatiom
  const finishJourney = function () {
    //navHandler(survey.pages.length - 1, "chapterFour", 4);
    //closeNav();

    hist.push("/survey-confirmation");
  };

  const openMarkedForLater = function () {
    if (visibleMarkedForLater.length > 0) setShowMarkedForLater(true);
  };

  const closeMarkedForLater = function () {
    setShowMarkedForLater(false);
  };

  // "See my wood cut" button is visible if all questions are answered
  const showSeeJourneyButton = calculateTotalProgress(survey) === 100;
  //survey?.pages[survey?.pages.length - 2].isAnswered;

  if (showMarkedForLater) {
    return (
      <>
        <BodyClassName className="body-nav" />
        <MarkForLaterList close={closeMarkedForLater} />
      </>
    );
  }

  const progressOne = calculateProgress(1, survey);
  const progressTwo = calculateProgress(2, survey);
  const progressThree = calculateProgress(3, survey);
  const progressFour = calculateProgress(4, survey);
  return (
    <>
      <BodyClassName className="body-nav" />
      {lastVisitedPage >= 0 && !survey?.isLastPage && (
        <button
          className="navigation-back link"
          onClick={() => {
            closeNav();
          }}
        >
          {t("button.return_to_question")}
        </button>
      )}

      {lastVisitedPage === -1 && (
        <div className="headline--secondary text-uppercase">{`${t(
          "start.line1"
        )} ${t("start.line2")} ${t("start.line3")}`}</div>
      )}

      <AppProgressInfo />

      <nav className="navigation" aria-label={t("nav.survey_navigation")}>
        <ul className="navigation-list">
          <li className={chapterClass(1, progressOne)}>
            <button
              onClick={() =>
                chapterActive(1) &&
                navHandler(calculateChapterPage(1), "chapterOne", 1)
              }
              className="nav-link"
              aria-disabled={!chapterActive(1)}
            >
              <div className="nav-link__title">
                <i className="icon icon-chapter-one"> </i>
                <div className="nav-link__wrap">
                  <span className="chapterName tag">
                    {t("survey.chapters.ch_1.label", { ns: "survey" })}
                  </span>
                  <h3 className="chapterTitle headline--quaternary">
                    {t("survey.chapters.ch_1.name", { ns: "survey" })}
                  </h3>
                </div>
              </div>
              <div className="active-arrow"></div>
              <ProgressBar progress={progressOne} />
            </button>
          </li>
          <li className={chapterClass(2, progressTwo)}>
            <button
              onClick={() =>
                chapterActive(2) &&
                navHandler(calculateChapterPage(2), "chapterTwo", 2)
              }
              className="nav-link"
              aria-disabled={!chapterActive(2)}
            >
              <div className="nav-link__title">
                <i className="icon icon-chapter-two"> </i>
                <div className="nav-link__wrap">
                  <span className="chapterName tag">
                    {t("survey.chapters.ch_2.label", { ns: "survey" })}
                  </span>
                  <h3 className="chapterTitle headline--quaternary">
                    {chapterActive(2) ? (
                      t("survey.chapters.ch_2.name", { ns: "survey" })
                    ) : (
                      <span>{t("nav.complete_one_unlock")}</span>
                    )}
                  </h3>
                </div>
              </div>
              <div className="active-arrow"></div>
              <ProgressBar progress={progressTwo} />
            </button>
          </li>
          <li className={chapterClass(3, progressThree)}>
            <button
              onClick={() =>
                chapterActive(3) &&
                navHandler(calculateChapterPage(3), "chapterThree", 3)
              }
              className="nav-link"
              aria-disabled={!chapterActive(3)}
            >
              <div className="nav-link__title">
                <i className="icon icon-chapter-three"></i>
                <div className="nav-link__wrap">
                  <span className="chapterName tag">
                    {t("survey.chapters.ch_3.label", { ns: "survey" })}
                  </span>
                  <h3 className="chapterTitle headline--quaternary">
                    {chapterActive(3) ? (
                      t("survey.chapters.ch_3.name", { ns: "survey" })
                    ) : (
                      <span>{t("nav.complete_two_unlock")}</span>
                    )}
                  </h3>
                </div>
              </div>
              <div className="active-arrow"></div>
              <ProgressBar progress={progressThree} />
            </button>
          </li>
          <li className={chapterClass(4, progressFour)}>
            <button
              onClick={() =>
                chapterActive(4) &&
                navHandler(calculateChapterPage(4), "chapterFour", 4)
              }
              className="nav-link"
              aria-disabled={!chapterActive(4)}
            >
              <div className="nav-link__title">
                <i className="icon icon-chapter-four"> </i>
                <div className="nav-link__wrap">
                  <span className="chapterName tag">
                    {t("survey.chapters.ch_4.label", { ns: "survey" })}
                  </span>
                  <h3 className="chapterTitle headline--quaternary">
                    {chapterActive(4) ? (
                      t("survey.chapters.ch_4.name", { ns: "survey" })
                    ) : (
                      <span>{t("nav.complete_three_unlock")}</span>
                    )}
                  </h3>
                </div>
              </div>
              <div className="active-arrow"></div>
              <ProgressBar progress={progressFour} />
            </button>
          </li>
          {visibleMarkedForLater.length > 0 && (
            <li
              className={
                visibleMarkedForLater.length
                  ? "navigation-list-item mark-for-later active"
                  : "navigation-list-item mark-for-later"
              }
            >
              <button
                className="nav-link"
                onClick={openMarkedForLater}
                aria-disabled={visibleMarkedForLater.length ? "false" : "true"}
              >
                <div className="nav-link__title">
                  <i className="icon icon-mark-for-later"></i>
                  <div className="nav-link__wrap">
                    <h3 className="chapterTitle headline--quaternary">
                      {t("nav.marked_for_later")}
                    </h3>
                    <span className="chapterName headline--quaternary text-transform-none">
                      {t("nav.marked_for_later_here")}
                    </span>
                  </div>
                </div>
                <div className="active-arrow"></div>
              </button>
            </li>
          )}
        </ul>
      </nav>
      <Cta
        tagName="button"
        ctaClass="cta--primary"
        iconClass={showSeeJourneyButton ? "icon-rings" : "icon-locked"}
        onClick={() => showSeeJourneyButton && finishJourney()}
        disabled={!showSeeJourneyButton}
      >
        {t("button.see_your_journey")}
      </Cta>
      <small className="paragraph">
        {showSeeJourneyButton
          ? t("nav.create_tree_rings")
          : t("nav.complete_all")}
      </small>
    </>
  );
}
